export const environment = {
  production: true,
  apiUrl: 'https://api.ajaraheritage.ge/api/',
  defaultDoamin: 'https://ajaraheritage.ge/',

};
